import React from "react";
import { StickyTopRowStack } from "../../../../components/commonComponents/StyledComponents/styled";
import { Box } from "@mui/material";
import StoreFilter from "../../../../components/commonComponents/Filters/StoreFilter";
import SingleSelectStoreFilter from "../../../../components/commonComponents/Filters/SingleSelectStoreFilter";
import { dbFormatDate, findStoreIds, formatToStandardDate, getFirstDayMonthsAgo, standardFormatToday, storeListOptionsForFilter } from "../../../../api_calls/utils";
import DateRangeFilter from "../../../../components/commonComponents/Filters/DateRangeFilter";
import { filterRangeValue, filterSingleValue } from "../../../../api_calls/TableauVisuals";
import { useDispatch, useSelector } from "react-redux";
import MultiSelect from "../../../../components/commonComponents/Selectors/MultiSelect";
import { findMinSelectableDate } from "../../../../api_calls/campaigns";
import DateRangeInputFields from "../../../../components/commonComponents/Filters/DateRangeInputFields";
import { updateStateData } from "../../../../Store/actions";

const statusOptions = ["Receipts available but not yet processed", "Receipts not yet received", "Receipts processed"];

const RecieptMonitoringFilter = ({ storeArr }) => {
  const userStateDate = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();
  let storeListMultiSelect = storeListOptionsForFilter("monitoring"); //for reciept monitoring
  const { date_range_start_date, date_range_end_date } = userStateDate;

  const firstDayThreeMonthsAgo = React.useMemo(() => {
    const today = standardFormatToday();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const dateBeforeThreeMonths = new Date(yesterday);
    // yesterday - 90 days
    dateBeforeThreeMonths.setDate(yesterday.getDate() - 90);
    return dateBeforeThreeMonths;
  }, []);

  const { minSelectableDate, maxSelectableDate } = React.useMemo(() => {
    const today = standardFormatToday();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const start = firstDayThreeMonthsAgo;
    const end = date_range_end_date
      ? new Date(date_range_end_date)
      : dbFormatDate(yesterday);

    return {
      minSelectableDate: start,
      maxSelectableDate: end < start ? yesterday : end,
    };
  }, [firstDayThreeMonthsAgo]);

  const [changesMade, setChangesMade] = React.useState(false);
  const [statusSelection, setStatusSelection] = React.useState(statusOptions);
  const [dataLoaded, setDataLoaded] = React.useState(false);
  const [selectedStatusName, setSelectedStatusName] = React.useState([]);

  const handleChange = (e) => {
    setChangesMade(true);
    setStatusSelection((preState) => {
      if (preState.includes("(All)") && !e.target.value.includes("(All)")) {
        return [];
      } else if (
        preState.includes("(All)") &&
        e.target.value.includes("(All)") &&
        e.target.value.length !== statusOptions.length
      ) {
        const selectedOptions = e.target.value.filter((option) => option !== "(All)");
        return selectedOptions;
      } else if (!preState.includes("(All)") && e.target.value.length === statusOptions.length - 1) {
        // Replace selection with "(All)"
        return statusOptions;
      } else {
        if (e.target.value.includes("(All)")) {
          return statusOptions;
        } else {
          return e.target.value.length === 0 ? [] : e.target.value;
        }
      }
    });
  };

  React.useEffect(() => {
    setStatusSelection(statusOptions);
    // findMinSelectableDate(storeArr);
    setSelectedStatusName(
      statusOptions.map((statusName) => {
        return { value: statusName, label: statusName };
      })
    );

    dispatchAction(updateStateData({
      "embedded_receipt_monitoring_status": {
        ...userStateDate.embedded_receipt_monitoring_status,
        "status": statusOptions,
        "store_ids": findStoreIds(storeListMultiSelect)
      },
    }));

    setTimeout(() => {
      setDataLoaded(true);
    }, 1000);
  }, []);

  return dataLoaded ? (
    <StickyTopRowStack direction={"row"} spacing={4} sx={{mr: 0}}>
      {/* ------- status filter ----------- */}
      <Box sx={{ width: 220 }}>
        <MultiSelect
          enableFullWidth={true}
          label="Status"
          options={statusOptions.map((statusName) => {
            return { value: statusName, label: statusName };
          })}
          defaultVal={selectedStatusName}
          selectionCheck={(option, value) => option.label === value.label}
          onBlurCall={(e) => {
            if (statusSelection.length !== 0 && changesMade === true) {
              dispatchAction(updateStateData({
                "embedded_receipt_monitoring_status": {
                  ...userStateDate.embedded_receipt_monitoring_status,
                  "status": statusSelection,
                },
              }));
              setChangesMade(false);
            }
          }}
          onChangeCall={(selectedOption) => {
            let userChoices = [];
            selectedOption.forEach((chosen) => {
              if (chosen.label !== "(All)") {
                userChoices.push(chosen.label);
              } else {
                userChoices.push([...new Set(statusOptions)]);
              }
            });
            setStatusSelection(userChoices);
            setSelectedStatusName(selectedOption);
            setChangesMade(true);
          }}
        />
      </Box>
      {/* ------- Date filter ------ */}
      <Box>
        <DateRangeInputFields
          minSelectableDate={minSelectableDate}
          maxSelectableDate={maxSelectableDate}
          reduxKeywordToSaveValue={"embedded_receipt_monitoring_date"}
        />
      </Box>
    </StickyTopRowStack>
  ) : (
    <></>
  );
};

export default RecieptMonitoringFilter;
